//Please add the language resource
const orderSignLog = {
  serialNo: 'serialNo',
  orderNo: 'orderNo:',
  signDate: 'signDate',
  signStatusName: 'signStatusName',
  remark: 'remark',
  dealStatusName: 'dealStatusName',
  dealCount: 'dealCount',
  dealTime: 'dealTime',
  dealResult: 'dealResult',
  createTime: 'createTime',
  detail: {
    itemNo: 'itemNo',
    skuCode: 'skuCode',
    skuDesc: 'skuDesc',
    batch: 'batch',
    signQty: 'signQty',
    rejectQty: 'rejectQty',
    rejectReasonNoName: 'rejectReasonNoName',
  },
  msg: {}
};
export default orderSignLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/orderSignLog/lang/orderSignLog.en.js